import React from 'react';
import { Link } from 'react-router-dom';
import { MinusIcon, PlusIcon, TruckIcon, TrashIcon } from 'lucide-react';
import { Drawer } from './Drawer';
import { useStore } from '../contexts/StoreContext';
export function CartDrawer() {
  const {
    cartOpen,
    closeCart,
    lines,
    setQty,
    remove,
    subtotal,
    freeShippingThreshold
  } = useStore();
  const remaining = Math.max(0, freeShippingThreshold - subtotal);
  const progress = Math.min(100, subtotal / freeShippingThreshold * 100);
  return <Drawer open={cartOpen} onClose={closeCart} title="Winkelmand" footer={lines.length > 0 ? <div data-id="element-59" data-mp="2qbm5ny0fl1ca">
            <div className="flex items-baseline justify-between" data-id="element-60" data-mp="2qc5bigct3z9y">
              <span className="text-sm text-muted" data-id="element-61" data-mp="2vagkkova25r4">Subtotaal</span>
              <span className="font-display text-2xl text-ink" data-id="element-62" data-mp="3j12qoalq1fyh">€ {subtotal}</span>
            </div>
            <p className="mt-1 text-[12px] text-muted" data-id="element-63" data-mp="3nrt0q153e6zi">
              Verzendkosten worden bij het afrekenen berekend.
            </p>
            <button type="button" className="mt-4 w-full rounded-full bg-ink py-3.5 text-sm text-shell transition-colors duration-150 ease-soft hover:bg-clay" data-id="element-64" data-mp="43r1o3duaj6w">
              Afrekenen
            </button>
            <button type="button" onClick={closeCart} className="mt-2 w-full py-2 text-[13px] text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-65" data-mp="cwudy8cr0pzy">
              Verder winkelen
            </button>
          </div> : undefined} data-id="element-58" data-mp="351td7iowgzy7">
      {lines.length === 0 ? <div className="flex h-full flex-col items-center justify-center text-center" data-id="element-66" data-mp="vsu7vopae3m6">
          <p className="font-display text-2xl text-ink" data-id="element-67" data-mp="rs0kcwfraqtt">Je mand is nog leeg</p>
          <p className="mt-3 max-w-xs text-sm leading-relaxed text-muted" data-id="element-68" data-mp="2xkyvwp3o0grm">
            Niet zeker wat je huid nodig heeft? Vraag eerst persoonlijk advies — dan koop je
            alleen wat werkt.
          </p>
          <Link to="/webshop" onClick={closeCart} className="mt-6 rounded-full border border-ink px-6 py-3 text-sm text-ink transition-colors duration-150 ease-soft hover:bg-ink hover:text-shell" data-id="element-69" data-mp="wjivf0y33u0f">
            Bekijk de collectie
          </Link>
        </div> : <>
          <div className="rounded-sm bg-sand p-4" data-id="element-70" data-mp="1bh1h1ufgtr3n">
            <p className="flex items-center gap-2 text-[13px] text-ink" data-id="element-71" data-mp="1fhv98zzxxs2c">
              <TruckIcon className="h-4 w-4 text-clay" strokeWidth={1.5} data-id="element-72" data-mp="1ffsjmh2pa0y5" />
              {remaining > 0 ? `Nog € ${remaining} tot gratis verzending` : 'Je verzending is gratis'}
            </p>
            <div className="mt-3 h-1 w-full overflow-hidden rounded-full bg-line" data-id="element-73" data-mp="1u6rkf5xanl76">
              <div className="h-full rounded-full bg-clay transition-[width] duration-300 ease-soft" style={{
            width: `${progress}%`
          }} data-id="element-74" data-mp="1u8lwduql82z4" />
            </div>
          </div>

          <ul className="mt-6 divide-y divide-line" data-id="element-75" data-mp="3np8gai6ny76z">
            {lines.map(({
          product,
          qty
        }) => <li key={product.id} className="flex gap-4 py-5" data-id="element-76" data-mp="3jo4yhq522134">
                <img src={product.image} alt={product.name} className="h-20 w-20 shrink-0 rounded-sm object-cover" data-id="element-77" data-mp="3jpznbfjg6dch" />
                <div className="flex flex-1 flex-col" data-id="element-78" data-mp="39ra6lq3aeyxt">
                  <p className="text-[11px] uppercase tracking-widest text-clay" data-id="element-79" data-mp="b8lab5j8r8ux">
                    {product.brand}
                  </p>
                  <h3 className="mt-1 font-display text-base leading-snug text-ink" data-id="element-80" data-mp="69igkh8pop29">
                    {product.name}
                  </h3>
                  <div className="mt-auto flex items-center justify-between pt-3" data-id="element-81" data-mp="3sousqpeo3jeq">
                    <div className="flex items-center gap-1 rounded-full border border-line" data-id="element-82" data-mp="3smqp88kokmez">
                      <button type="button" aria-label={`Minder ${product.name}`} onClick={() => setQty(product.id, qty - 1)} className="p-2 text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-83" data-mp="u0e595hvf45a">
                        {qty === 1 ? <TrashIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-84" data-mp="3vymbwrzercrm" /> : <MinusIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-85" data-mp="4r0br9bwdsfi" />}
                      </button>
                      <span className="min-w-[1.5rem] text-center text-[13px] text-ink" data-id="element-86" data-mp="xf5z83uc5vj1">
                        {qty}
                      </span>
                      <button type="button" aria-label={`Meer ${product.name}`} onClick={() => setQty(product.id, qty + 1)} className="p-2 text-muted transition-colors duration-150 ease-soft hover:text-ink" data-id="element-87" data-mp="iq00egzeu7bo">
                        <PlusIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-88" data-mp="1g7qc4btn3q17" />
                      </button>
                    </div>
                    <span className="font-display text-base text-ink" data-id="element-89" data-mp="2vxraf2svn67h">
                      € {product.price * qty}
                    </span>
                  </div>
                </div>
                <button type="button" onClick={() => remove(product.id)} aria-label={`${product.name} verwijderen`} className="self-start p-1 text-muted/60 transition-colors duration-150 ease-soft hover:text-ink" data-id="element-90" data-mp="35nato9ki522v">
                  <TrashIcon className="h-3.5 w-3.5" strokeWidth={1.5} data-id="element-91" data-mp="2qxweuly5psg3" />
                </button>
              </li>)}
          </ul>
        </>}
    </Drawer>;
}